var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBasketAnimation = function SvgBasketAnimation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.076 11c.375-2.401 2.078-4 3.924-4 1.845 0 3.549 1.599 3.924 4zm-2.015 0c.4-3.26 2.729-6 5.939-6s5.539 2.74 5.939 6h2.908a2 2 0 0 1 1.98 2.283l-1.714 12A2 2 0 0 1 23.133 27H8.867a2 2 0 0 1-1.98-1.717l-1.714-12A2 2 0 0 1 7.153 11zm-2.908 2h17.694l-1.714 12H8.867z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12.076 11c.375-2.401 2.078-4 3.924-4 1.845 0 3.549 1.599 3.924 4zm-2.015 0c.4-3.26 2.729-6 5.939-6s5.539 2.74 5.939 6h2.908a2 2 0 0 1 1.98 2.283l-1.714 12A2 2 0 0 1 23.133 27H8.867a2 2 0 0 1-1.98-1.717l-1.714-12A2 2 0 0 1 7.153 11zm-2.908 2h17.694l-1.714 12H8.867z",
    clipRule: "evenodd"
  })));
};
export default SvgBasketAnimation;